module.exports = __webpack_public_path__ + "img/modelo-cs1.2f77f0ee.png";